import type { HoverActionItem } from "@promptlayer/ui";
import { ChatBubble } from "@promptlayer/ui";

import { MessageAvatar } from "@/components/Playground/Drawer/Chat/ChatMessage/MessageAvatar";

export const JsonBubble = ({
  isRightAligned,
  jsonText,
  hoverActions,
}: {
  isRightAligned: boolean;
  jsonText: string;
  hoverActions: HoverActionItem[];
}) => (
  <ChatBubble
    role={isRightAligned ? "user" : "assistant"}
    avatar={!isRightAligned ? <MessageAvatar /> : undefined}
    hoverActions={hoverActions}
    bubbleClassName="border border-gray-200 bg-gray-50 text-gray-700"
    disableAnimation
  >
    <pre className="overflow-x-auto whitespace-pre-wrap break-words font-mono text-xs leading-relaxed text-gray-700">
      {jsonText}
    </pre>
  </ChatBubble>
);
